/* 
    OTEVRENO - lze ještě přidávat požadavky 
    UZAVRENO - nelze již přidávat požadavky
    VYRIZENO - vyřízeno
*/
export enum EStavPozadavku {
    OTEVRENO = 'OTEVRENO',
    UZAVRENO = 'UZAVRENO',
    VYRIZENO = 'VYRIZENO'
}
